// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__2cidd","label":"LabeledBox_label__3yJ3T"};